// extracted by mini-css-extract-plugin
export default {"cars":"styles_cars__TnHo0","leftbutton":"styles_leftbutton__5gEvn","rightbutton":"styles_rightbutton__xLRve"};